<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ $t(title) }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text
        v-if="!!message"
        class="primary--text pa-4 pb-8 font-weight-bold body-1"
        >{{ $t(message) }}</v-card-text>
        <v-card-text
         v-if="!!rowMessage"
         class="primary--text pa-4 pb-8 font-weight-bold body-1"
         >{{ rowMessage }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="agree" class="body-1">
          {{ $t("CONFIRM") }}
        </v-btn>
        <v-btn color="error" @click.native="cancel" class="body-1">
          {{ $t("CANCEL") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ad-confirmDialog",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    rowMessage:null,
    title: null,
    options: {
      color: "primary",
      width: 370,
      zIndex: 200
    }
  }),
  methods: {
    open(title, message, options, rowMessage=null) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.rowMessage = rowMessage;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
